import { IconWrapper } from '../runtime';
export default IconWrapper('exit', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M11.0024 1.6745C13.366 2.79845 15 5.20828 15 7.99974C15 11.8657 11.866 14.9997 8 14.9997C4.13401 14.9997 1 11.8657 1 7.99974C1 5.20702 2.63542 2.79628 5.0008 1.67299M8 5.76421V0.969429",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});